<div #conversationContainer class="scroll-y me-n5 mx-n5 card-body" [ngClass]="!isDrawer ? 'h-300px h-lg-auto' : ''"
  data-kt-element="messages" data-kt-scroll="true" data-kt-scroll-activate="{default: false, lg: true}"
  data-kt-scroll-max-height="auto" [attr.data-kt-scroll-dependencies]="
    isDrawer
      ? '#kt_drawer_chat_messenger_header, #kt_drawer_chat_messenger_footer'
      : '#kt_header, #kt_toolbar, #kt_footer, #kt_chat_messenger_header, #kt_chat_messenger_footer'
  " [attr.data-kt-scroll-wrappers]="
    isDrawer
      ? '#kt_drawer_chat_messenger_body'
      : '#kt_content, #kt_chat_messenger_body'
  " [attr.data-kt-scroll-offset]="isDrawer ? '0px' : '-2px'">
  <ng-container  *ngIf="chatService.currentAction.value==='conversation'">
    <ng-container *ngIf="conversations$ | async as conversations ; else isLoad">
      <ng-container *ngFor="let message of conversations; let is_last=last">
        <div [ngClass]="{
            'd-flex': !isDrawer,
            'd-none': message.template,
            'justify-content-start': message.type === 'in',
            'justify-content-end': message.type !== 'in'
          }" [attr.data-kt-element]="'template-' + message.type" class="mb-10">
          <div class="d-flex flex-column align-items"
            [ngClass]="'align-items-' + (message.type === 'in' ? 'start' : 'end')">
            <div class="d-flex align-items-center mb-2">
              <ng-container *ngIf="message.type === 'in'">
                <div  class="symbol symbol-35px symbol-circle">
                  <img alt="Pic" [src]="'./assets/assistant/massist_icon.svg'" />
                </div>
                <div class="ms-3">
                  <a href="#" class="fs-5 fw-bolder text-gray-900 text-hover-primary me-1" translate>
                    assistant.assistant
                  </a>
                  <span class="text-muted fs-7 mb-1">{{ message.time }}</span>
                </div>
              </ng-container>
              <ng-container *ngIf="message.type !== 'in'">
                <div class="me-3">
                  <span class="text-muted fs-7 mb-1">{{ message.time }}</span>
                  <a href="#" class="fs-5 fw-bolder text-gray-900 text-hover-primary ms-1">
                    Vous
                  </a>
                </div>
                <div class="symbol symbol-35px symbol-circle" *ngIf="userData$ |async as userData">
                  <img [src]="(avatarImage$| async) ?? userData.avatar ?? ''" alt="avatar" lcmsAvatarAsLetter [email]="userData?.email"/>
                </div>
              </ng-container>
            </div>
            <!-- <div *ngIf="is_last && true===message.typping" #botResponseOutput class="message-text p-5 rounded text-dark fw-bold mw-lg-400px" [class]="{'bg-light-info':message.type === 'in', 'text-start':message.type === 'in', 'bg-light-primary':message.type !== 'in', 'text-end':message.type !== 'in' }"></div> -->
            <div *ngIf="!is_last"  class="message-text p-5 rounded text-dark fw-bold mw-lg-400px" [class]="{'bg-light-info':message.type === 'in', 'text-start':message.type === 'in', 'bg-light-primary':message.type !== 'in', 'text-end':message.type !== 'in' }">
              <ng-container *ngFor="let msg of message.text">
                <div class="mb-4" *ngIf="msg.type==='text'"  [innerHTML]="msg?.content | safe: 'html'"></div>
                <div *ngIf="msg.type==='resources-viewer'" class="row row-cols-3 mb-4 g-2">
                  <ng-container *ngFor=" let item of  msg.content" >
                    <ng-container lcmsDynamicComponentChat [cmpData]="item" [cmpType]="msg.type"></ng-container>
                  </ng-container>
                </div>
                <div class="d-flex justify-content-center mh-500px scroll-y"  style="width: 350px !important;" *ngIf="msg.type==='survey-viewer'">
                    <lcms-survey-viewer [surveydata]="msg.content" (surveyResponse)="sendresponse($event)"></lcms-survey-viewer>
                </div>
                <div *ngIf="msg.type==='user-response'">
                  <span>
                   {{'Notification.myResponse'|translate}}
                    <span [inlineSVG]="'./assets/media/icons/duotune/communication/com009.svg'" class="text-primary"> </span>
                 </span>
                </div>
                <div *ngIf="msg.type==='sessions-viewer'" >
                  <lcms-session-viewer [items]="msg.content" ></lcms-session-viewer>
                </div>
                <div *ngIf="msg.type==='event-viewer'">
                  <lcms-event-viewer [items]="msg.content" ></lcms-event-viewer>
                </div>
              </ng-container>
            </div>
            <div *ngIf="is_last && true!==message.typping"  class="message-text p-5 rounded text-dark fw-bold mw-lg-400px" [class]="{'bg-light-info':message.type === 'in', 'text-start':message.type === 'in', 'bg-light-primary':message.type !== 'in', 'text-end':message.type !== 'in' }" >
              <ng-container *ngFor="let msg of message.text">
                <div class="mb-4" *ngIf="msg.type==='text'"  [innerHTML]="msg?.content | safe: 'html'"></div>
                <div *ngIf="msg.type==='resources-viewer'" class="row row-cols-3 my-4 g-2">
                  <ng-container *ngFor=" let item of  msg.content" >
                    <ng-container lcmsDynamicComponentChat [cmpData]="item" [cmpType]="msg.type" ></ng-container>
                  </ng-container>

                </div>
                <div *ngIf="msg.type==='sessions-viewer'" >
                  <lcms-session-viewer [items]="msg.content" ></lcms-session-viewer>
                </div>
                <div *ngIf="msg.type==='event-viewer'">
                  <lcms-event-viewer [items]="msg.content" ></lcms-event-viewer>
                </div>
                <div class="d-flex justify-content-center mh-500px scroll-y" style="width: 350px !important;" *ngIf="msg.type==='survey-viewer'">
                  <lcms-survey-viewer [surveydata]="msg.content" (surveyResponse)="sendresponse($event)"></lcms-survey-viewer>
                </div>
                <div *ngIf="msg.type==='user-response'">
                 <span>
                   {{'Notification.myResponse'|translate}}
                    <span [inlineSVG]="'./assets/media/icons/duotune/communication/com009.svg'" class="text-primary"> </span>
                 </span>
                </div>
              </ng-container>
            </div>
            <div *ngIf="is_last && true===message.typping" class="message-text p-3 rounded text-dark fw-bold mw-lg-400px" [class]="{'bg-light-info':message.type === 'in', 'text-start':message.type === 'in', 'bg-light-primary':message.type !== 'in', 'text-end':message.type !== 'in' }">
              <div class="typing-indicator">
                <div class="typing-circle"></div>
                <div class="typing-circle"></div>
                <div class="typing-circle"></div>
                <div class="typing-shadow"></div>
                <div class="typing-shadow"></div>
                <div class="typing-shadow"></div>
            </div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <ng-template #isLoad>
    <div class="w-100 h-100 d-flex flex-column justify-content-center align-items-center" translate>
<!--      assistant.loading-->
      <img class="loading-logo" src="./assets/img/loading-logo.gif" alt="Mobiletic loading" />

    </div>
</ng-template>
  </ng-container>

  <!-- ng if show historique -->
  <ng-container *ngIf="chatService.currentAction.value==='history' ">
    <ng-container  *ngIf="histories$ | async as histories;else loadHistory ">
    <div *ngFor="let history of histories" (click)="loadSelectedConv(history?.conversation_id)"  class="history-item  cursor-pointer  px-2 py-1 my-2 rounded-2 text-gray-900 w-100" >
      <p class="history-title m-0 ">{{history.title}}</p>
      <div class="d-flex justify-content-between align-items-center">
        <span>{{ history.createdAt}}</span>
        <div class=" d-flex flex-row-reverse align-items-center  gap-2 w-25 ">
          <span class="text-remaining">{{history.remaining}} {{'assistant.jours' | translate}} </span>
<!--          <i class="bi bi-hourglass-top  text-remaining"></i>-->
          <span class="sv   g-icon text-remaining" [inlineSVG]="'./assets/media/icons/duotune/general/gen012.svg'"></span>
        </div>
      </div>
    </div>
    </ng-container>
    <ng-template #loadHistory>
      <div class="w-100 h-100 d-flex flex-column justify-content-center align-items-center" translate>
<!--        assistant.loading-->
        <img class="loading-logo" src="./assets/img/loading-logo.gif" alt="Mobiletic loading" />

      </div>
    </ng-template>
  </ng-container>
</div>

<div class="card-footer p-0 py-5" [id]="
    isDrawer ? 'kt_drawer_chat_messenger_footer' : 'kt_chat_messenger_footer'
  ">
  <!-- TODO: Désactiver le text et le bouton quand isSending est true -->
  <!-- <div>{{isSending$ | async}}</div> -->
<div *ngIf="chatService.currentAction.value==='conversation'" class="container">
  <form class="d-flex flex-stack  align-items-baseline" [formGroup]="monFormulaire" (ngSubmit)="onSubmit()">
    <input type="text" class="form-control mb-3 me-2" formControlName="message" />
    <button type="submit"   class="btn btn-primary p-3 btn-submit"><span [inlineSVG]="'./assets/media/icons/duotune/general/gen016.svg'"></span></button>
  </form>

</div>

  <!-- <div class="container">
    <div class="d-flex flex-stack  align-items-baseline">
      <input [disabled]="(isSending$ | async) === true" #messageInput class="form-control mb-3 me-2"
        data-kt-element="input" placeholder="Taper un message" type="tex" (keyup.enter)="submitMessage()" />

      <button [disabled]="!messageInput.value || (isSending$ | async) === true" class="btn btn-primary p-3"
        type="button" data-kt-element="send" (click)="submitMessage()">
        <span [inlineSVG]="'./assets/media/icons/duotune/general/gen016.svg'"></span>
      </button>
    </div>
  </div> -->
</div>
